import styled from 'styled-components';

import Section from '../components/Section';
import useModal from 'hooks/useModal';
import UserDeleteModal from 'components/modals/UserDeleteModal/UserDeleteModal';

const Container = styled.div``;

const Text = styled.span`
  display: block;
  margin-top: 4px;
`;

const Button = styled.button`
  color: ${(props) => props.theme.global.errorColor};
  text-decoration: underline;
  font-size: 15px;
  margin-top: 14px;
`;

const DeleteSection = () => {
  const modal = useModal();

  const handleDeleteButtonClick = () => {
    modal.render({
      key: 'userDelete',
      modal: <UserDeleteModal />,
    });
  };

  return (
    <Section title="계정 삭제">
      <Container>
        <Text>계정을 삭제하면 계정과 연결된 프로젝트, 즐겨찾기, 좋아요, 댓글 등 모든 정보가 삭제됩니다.</Text>
        <Button onClick={handleDeleteButtonClick}>계정 삭제</Button>
      </Container>
    </Section>
  );
};

export default DeleteSection;
